module.exports = __webpack_public_path__ + "static/media/icon_caizhon.6307761d.png";